import edit from '../Images/edit.svg';
import approval from '../Images/approval.svg';
import estamp from '../Images/estamp.svg';
import approvalrequest from '../Images/approvalrequest.svg';
import branch from '../Images/branch.svg';
import users from '../Images/users.svg';
import Logo from '../../Assets/Images/svgs/Logo.svg';
import { ReactComponent as Dashboard } from '../../Assets/Images/svgs/Dashboard.svg';
import { ReactComponent as ActionRequired } from '../../Assets/Images/svgs/ActionRequired.svg';
import { ReactComponent as WaitingForOthers } from '../../Assets/Images/svgs/WaitingForOthers.svg';
import { ReactComponent as Signed } from '../../Assets/Images/svgs/Signed.svg';
import { ReactComponent as UnsuccessfulWorkflows } from '../../Assets/Images/svgs/UnsuccessfulWorkflows.svg';
import { ReactComponent as Template } from '../../Assets/Images/svgs/Template.svg';
import { ReactComponent as User } from '../../Assets/Images/svgs/user-octagon.svg';
import { ReactComponent as Wallet } from '../../Assets/Images/svgs/wallet.svg';
import { ReactComponent as Settings } from '../../Assets/Images/svgs/settings.svg';
import { ReactComponent as WalletHistory } from '../../Assets/Images/WalletHistory.svg';
import stampReq from '../Images/stamp-request.svg';
import order from '../Images/order.svg';
import forward from '../Images/forward-to.svg';
import { routeConstants } from '../../utils/path-constants';


export const notificationData = [
	{
		id: 1,
		title: 'Cover Letter.pdf',
		createdBy: 'By Utkarsh ',
		status: 'To approve',
		approvalStatus: 'Sent for approval | Jun 21, 2023'
	},
	{
		id: 2,
		title: 'Cover Letter.pdf',
		createdBy: 'By Amit ',
		status: 'Complete',
		approvalStatus: 'Signed by all the recipients '
	},
	{
		id: 3,
		title: 'Cover Letter.pdf',
		createdBy: 'By Swapnil ',
		status: 'To approve',
		approvalStatus: 'Sent for approval | Jun 21, 2023'
	},
	{
		id: 4,
		title: 'Cover Letter.pdf',
		createdBy: 'By Sahail ',
		status: 'Complete',
		approvalStatus: 'Signed by all the recipients '
	}
];

export const dashboardNavData = [
	{
		id: 1,
		title: 'e-Sign Documents',
		icon: edit,
		subTabs: [
			{ id: 10, value: 'drafts' },
			{ id: 11, value: 'Awaiting Action',statusFilterOptions: [
				'Procurement InProgress',
				'Payment Pending',
				'Awaiting Signing'
			] },
			{ id: 12, value: 'Signed Documents' },
			{ id: 13, value: 'Unsuccessful Workflows',statusFilterOptions: [
				'Rejected Approval',
				'Procurement Failed',
				'Payment Failed',
				'Payment Expired',
				'Customer Rejected',
				'Signing Expired',     
				'Verification Failed',
				'eStamp Cancelled',
				'Rejected Edit Approval',
				'Rejected Cancel Approval',
			]
			},
			{ id: 15, value: 'bulk e-Sign' }
		]
	},
	{
		id: 2,
		title: 'Approval from checker',
		icon: approval,
		subTabs: [
			{ id: 20, value: 'sent',statusFilterOptions: [
				'Awaiting Approval',
				'Awaiting Edit Approval',
				'Awaiting Cancel Approval'
			] },
			{ id: 21, value: 'approved',statusFilterOptions: [
				'Payment Pending',
				'Signed',
				'Awaiting Signing',
				'Procurement InProgress',
				'Procurement Failed',
				'eStamp Cancelled',
				'Payment Failed',
				'Payment Expired',
				'Customer Rejected',
				'Signing Expired',
				'Verification Failed'
			]
			},
			{ id: 22, value: 'rejected',statusFilterOptions:[
				'Rejected Approval',
				'Rejected Edit Approval',
				'Rejected Cancel Approval',
				'Cancelled' 
			] }
		]
	},
	{
		id: 3,
		title: 'Stamping',
		icon: estamp,
		subTabs: [
			{ id: 30, value: 'order Request' },
			{ id: 31, value: 'awaiting Approval' },
			{ id: 32, value: 'order Confirmed' },
			{ id: 33, value: 'rejected' },
			{ id: 34, value: 'Inventory' }
			// { id: 34, value: 'e-stamp history' }
		]
	},
	{ id: 4, title: 'Approval Requests', icon: approvalrequest, subTabs: [] },
	{
		id: 5,
		title: 'Stamp Requests',
		icon: stampReq,
		subTabs: [
			{ id: 50, value: 'Digital Stamp' }
			// { id: 51, value: 'dropdown' }
		]
	},
	{
		id: 6,
		title: 'Forwarded to vendor',
		icon: forward,
		subTabs: [
			{ id: 60, value: 'Digital Stamp' }
			// { id: 51, value: 'dropdown' }
		]
	},
	{
		id: 7,
		title: 'Orders',
		icon: order,
		subTabs: [
			{ id: 70, value: 'Digital Stamp' }
			// { id: 51, value: 'dropdown' }
		]
	},
	{
		id: 8,
		title: 'Forwarded to Customers',
		icon: forward,
		subTabs: [
			{ id: 80, value: 'Digital Stamp' }
			// { id: 51, value: 'dropdown' }
		]
	},
	{
		id: 9,
		title: 'Received orders',
		icon: stampReq,
		subTabs: [
			{ id: 90, value: 'Stamp Request' },
			{ id: 91, value: 'Accepted Orders' },
			{ id: 92, value: 'Rejected Orders' }
		]
	},
	{
		id: 10,
		title: 'Sent orders',
		icon: forward,
		subTabs: [{ id: 100, value: 'Digital Stamp' }]
	}
];

export const dashboardColumnData = [
	// 0 0
	[
		[],
		// 01
		[],
		//02
		[],
		//03
		[]
	],
	//10
	[
		[], //11

		[],
		//12

		[]
	],
	//20
	[
		[],
		//21
		[],
		//22
		[]
	],
	//30
	[
		[],
		//31
		[],
		//32
		[]
	],
	[[]]
];

export const data = [
	{
		eSign: {
			drafts: [],

			'await Signings': [],
			signed: [],
			'customer Rejected': []
		},
		approval: {
			sent: [],
			approved: [],
			rejected: []
		},
		eStamps: {
			'order placed': [],

			'awaiting Approval': [],

			'order Confirmed': []
		},
		'digi stamps': {
			orderPlaced: [],
			awaitingApproval: [],
			orderConfirmed: []
		},
		approvalrequest: {
			orderPlaced: []
		}
	}
];

let branchStaticColumns = [
	{
		value: 'Sr No.',
		id: 'id',
		flexVal: 0.5
	},
	{
		value: 'Branch ID',
		id: 'branchId',
		flexVal: 1
	},
	{
		value: 'Branch Name',
		id: 'name',
		flexVal: 1
	},
	{
		value: 'Location',
		id: 'location',
		flexVal: 1
	},
	{
		value: 'State',
		id: 'state',
		flexVal: 1
	},
	{
		value: 'City',
		id: 'city',
		flexVal: 1
	},
	{
		value: 'Pincode',
		id: 'pincode',
		flexVal: 1
	},
	{
		value: 'status',
		id: 'status',
		flexVal: 0.5
	}
];

export const columnDataForUserAndBranch = [
	[
		...branchStaticColumns.map(val => {
			return {
				field: val.id,
				headerName: val.value,
				display: val.flexVal,
				editable: false,
				positionInExcel: 1
			};
		})
	],
	[
		{
			field: 'id',
			headerName: 'Sr No.',
			flex: 0.5,
			display: 'flex',
			editable: false,
			positionInExcel: 1
		},
		{
			field: 'name',
			headerName: 'User Name',
			flex: 0.5,
			display: 'flex',
			editable: false,
			positionInExcel: 2
		},
		{
			field: 'email',
			headerName: 'Email Id',
			flex: 1,
			display: 'flex',
			editable: false,
			positionInExcel: 3
		},

		{
			field: 'mobileNo',
			headerName: 'Mobile No',
			flex: 0.8,
			width: 150,
			editable: false,
			positionInExcel: 4
		},
		// {
		//   field: 'date',
		//   headerName: 'Date',
		//   flex: 1,
		//   width: 110,
		//   editable: false
		// },
		{
			field: 'role',
			headerName: 'Role',
			description: 'This column has a department getter and is not sortable.',
			flex: 0.8,
			sortable: false,
			width: 160,
			positionInExcel: 7
		},
		{
			field: 'groupingId',
			headerName: 'Branch Name',
			description: 'This column has a department getter and is not sortable.',
			flex: 0.8,
			sortable: false,
			width: 160,
			positionInExcel: 4
		},
		{
			field: 'departmentId',
			headerName: 'Department',
			flex: 0.5,
			description: 'This column has a department getter and is not sortable.',
			sortable: false,
			width: 160,
			positionInExcel: 6
		},
		{
			field: 'status',
			headerName: 'Status',
			flex: 1,
			description: 'This column has a department getter and is not sortable.',
			sortable: false,
			positionInExcel: 8
		}
	],
	[]
];

export const tabsDataForUserAndBranch = [
	{ title: 'Branch', icon: branch },
	{ title: 'Users', icon: users }
];

export const paramsListArr = [
	{
		id: 'branchId',
		title: 'Id',
		type: 'textField',
		width: '6',
		placeholder: 'Id',
		regexPattern: /^[^\s]{1,20}$/,
		error: '',
		value: ''
	},
	{
		id: 'name',
		title: 'Name',
		type: 'textField',
		width: '6',
		placeholder: 'Name',
		regexPattern: /^(?! )[A-Z][a-zA-Z\s]{0,49}$/,
		error: '',
		value: ''
	},
	{
		id: 'location',
		title: 'Location',
		type: 'textField',
		width: '12',
		placeholder: 'Flat, house no., building, apartment, etc.',
		regexPattern: /^[\s\S]{1,100}$/,
		error: '',
		value: ''
	},
	{
		id: 'pincode',
		title: 'Pincode',
		type: 'textField',
		width: '12',
		placeholder: 'Pin Code',
		regexPattern: /^[1-9]\d{5}$/,
		error: '',
		value: ''
	},
	{
		id: 'state',
		title: 'State',
		type: 'textField',
		width: '12',
		placeholder: 'State',
		regexPattern: /^[a-zA-Z]*$/,
		error: '',
		value: ''
	},
	{
		id: 'city',
		title: 'City',
		type: 'textField',
		width: '12',
		placeholder: 'City',
		regexPattern: /^(?!.* $)(?! )[A-Z][a-zA-Z\s]*[^\s]$|^$/,
		error: '',
		value: ''
	},
	{
		id: 'district',
		title: 'District',
		type: 'textField',
		width: '12',
		placeholder: 'District',
		regexPattern: /^(?!\s)([A-Z][a-zA-Z\s]*[^\s0-9])?$/,

		error: '',
		value: ''
	}
];

export const sideBarMenu = [
	{ image: Logo, link: '/statistics', showMobile: false, logo: false, title: 'Logo' },
	{ image: Dashboard, link: '/dashboard', showMobile: true, logo: true, title: 'Dashboard' },
	{ image: Template, link: '/template', showMobile: true, logo: true, title: 'Template' },
	{ image: User, link: '/uam', showMobile: true, logo: true, title: 'UAM' },
	{ image: Wallet, link: '/wallet', showMobile: true, logo: true, title: 'Wallet' },
	{ image: WalletHistory, link: '/walletHistory', showMobile: true, logo: true, title: 'History' },
	{ image: Settings, link: '/setting', showMobile: false, logo: true, title: 'Settings' }
];


export const individualSidebarMenu = [
	{ image: Logo, link: '/statistics', showMobile: false, logo: false, title: 'Logo' },
	{ image: ActionRequired, link: routeConstants.ACTION_REQUIRED, showMobile: true, logo: true, title: 'Action Required' },
	{ image: WaitingForOthers, link: routeConstants.WAITING_FOR_OTHERS, showMobile: true, logo: true, title: 'Waiting For Others' },
	{ image: Signed, link: routeConstants.SIGNED, showMobile: true, logo: true, title: 'Signed' },
	{ image: UnsuccessfulWorkflows, link: routeConstants.UNSUCCESSFUL_WORKFLOWS, showMobile: true, logo: true, title: 'Unsuccessful Workflows' },
];

export const dataFormat = {
	documentName: { type: 'string' },
	documentType: { type: 'string' },
	referenceId: { type: 'string' },
	recipientData: { type: 'string' },
	recipientSentAt: { type: 'date' },
	updatedAt: { type: 'date' },
	documentSignType: { type: 'string' },
	isStampDutyRequired: { type: 'boolean' },
	stampType: { type: 'string' },
	stampAmount: { type: 'number' },
	status: { type: 'singleSelect', valueOptions: ['Payment Failed', 'Payment Expired'] },
	totalamount: { type: 'number' },
	paymentStatus: { type: 'string' }
};